import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { reduxForm, change } from 'redux-form';
import { useIntl } from 'react-intl';
import { Form } from 'react-bootstrap';
import withStyles from 'isomorphic-style-loader/withStyles';
import cx from 'classnames';

import CommonFields from '../CommonFields/CommonFields';
import submit from './submit';
import validate from './validate';
import messages from '../../locale/messages';

import bt from '../../components/commonStyle.css';
import s from './EditProfileForm.css';

const EditProfileForm = ({ error, handleSubmit, initialValues }) => {
  const dispatch = useDispatch();
  const { formatMessage } = useIntl();

  useEffect(() => {
    if (initialValues?.email) {
      dispatch(change('EditProfileForm', 'loggedinEmail', initialValues.email));
    }
  }, [dispatch, initialValues]);

  const title = <span>{formatMessage(messages.editProfileInfo)}</span>;

  return (
    <div className={cx('inputFocusColor', 'commonListingBg', 'inputDateHide', 'noMarginBottom')}>
      {error && <span className={s.errorMessage}>{formatMessage(error)}</span>}
      <h3 className={cx(bt.listingTitleText, bt.space5)}>{title}</h3>
      <Form onSubmit={handleSubmit(submit)}>
        <CommonFields initialValues={initialValues} userId={initialValues?.userId} />
      </Form>
    </div>
  );
};

export default reduxForm({
  form: 'EditProfileForm', // a unique name for this form
  validate,
  enableReinitialize: true,
})(withStyles(bt, s)(EditProfileForm));